var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", { class: _vm.rootClass }, [
    !_vm.isSearch
      ? _c("td", { staticClass: "td_board", attrs: { scope: "row" } }, [
          _c("div", { staticClass: "board_state" }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "td_title",
        attrs: { scope: "row", colspan: _vm.colspan },
      },
      [
        _c("strong", { staticClass: "tit_board" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.message) + "\n\t\t\t"),
          _c("span", { staticClass: "box_regulation" }, [
            _c(
              "a",
              {
                staticClass: "link_regulation",
                attrs: { href: _vm.blindArticleUrl },
              },
              [_vm._v("원문보기")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "link_regulation",
                attrs: { href: _vm.restrictionUrl, target: "_blank" },
              },
              [_vm._v("규제관련 안내")]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }